var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0667 7.69327C9.9226 7.56228 9.73322 7.49242 9.53857 7.49844C9.34391 7.50446 9.15921 7.58588 9.02346 7.72552L7.22871 9.57127C6.79671 9.48877 5.92821 9.21802 5.03421 8.32627C4.14021 7.43152 3.86946 6.56077 3.78921 6.13177L5.63346 4.33627C5.77327 4.20061 5.85481 4.01588 5.86083 3.82117C5.86685 3.62646 5.79688 3.43705 5.66571 3.29302L2.89446 0.245769C2.76324 0.101287 2.58087 0.0136473 2.38608 0.00146384C2.19128 -0.0107196 1.99941 0.0535128 1.85121 0.180519L0.223712 1.57627C0.0940449 1.70641 0.0166511 1.87961 0.00621147 2.06302C-0.00503853 2.25052 -0.219538 6.69202 3.22446 10.1375C6.22896 13.1413 9.99246 13.361 11.029 13.361C11.1805 13.361 11.2735 13.3565 11.2982 13.355C11.4816 13.3448 11.6547 13.267 11.7842 13.1368L13.1792 11.5085C13.3063 11.3604 13.3707 11.1686 13.3586 10.9738C13.3466 10.779 13.2591 10.5966 13.1147 10.4653L10.0667 7.69327Z",
    fill: "#7DAB1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector1.5416687ae1f52d70486ba341dbbe23f4.svg";
export { ForwardRef as ReactComponent };